(function ($) {
  let slideBarToggle = null;

  function toggleDropdown(event) {
    event.preventDefault();
    event.stopPropagation();

    const $toggle = $(this);
    const $li = $toggle.closest('.dropdown');
    const $subnav = $li.children('.dropdown__subnav-wrapper');

    if ($li.hasClass('opened')) {
      $li.removeClass('opened');
      $subnav.slideUp('fast');
    } else {
      $li.addClass('opened');
      $subnav.slideDown('fast');
    }
  }

  function toggleSubDropdown(event) {
    event.preventDefault();
    event.stopPropagation();

    const $navWrapper = $('.nav-mobile-wrapper');
    const $toggle = $(this);
    const $li = $toggle.closest('.dropdown');
    const $subnav = $li.children('.dropdown__subnav-wrapper');
    const $topLinks = $('.mobile-menu__top-links');

    if ($navWrapper.hasClass('submenu-opened')) {
      $navWrapper.removeClass('submenu-opened');
    } else {
      $navWrapper.addClass('submenu-opened');
    }

    if ($topLinks.hasClass('submenu-opened')) {
      $topLinks.removeClass('submenu-opened');
    } else {
      $topLinks.addClass('submenu-opened');
    }

    if ($subnav.hasClass('submenu--opened')) {
      $subnav.removeClass('submenu--opened');
    } else {
      $subnav.addClass('submenu--opened');
      $('#mobile-menu').scrollTop(0);
    }
  }

  function closeSubDropdown(event) {
    event.preventDefault();
    event.stopPropagation();

    const $navWrapper = $('.nav-mobile-wrapper');
    const $subNavWrapper = $(
      '.dropdown__subnav-wrapper .subnav-wrapper-depth-1'
    );
    const $topLinks = $('.mobile-menu__top-links');

    if ($navWrapper.hasClass('submenu-opened')) {
      $navWrapper.removeClass('submenu-opened');
    } else {
      $navWrapper.addClass('submenu-opened');
    }

    if ($topLinks.hasClass('submenu-opened')) {
      $topLinks.removeClass('submenu-opened');
    } else {
      $topLinks.addClass('submenu-opened');
    }

    $subNavWrapper.removeClass('submenu--opened');
  }

  function prepareDropdownForNav($nav) {
    ///// INIT SLIDER POSITION /////
    $nav.find('.active').addClass('opened');

    $nav
      .find('.dropdown')
      .filter(':not(.opened)')
      .each(function () {
        $(this)
          .children('.dropdown__subnav-wrapper.subnav-wrapper-depth-0')
          .slideUp(0);
      });

    ///// INIT EVENTS /////
    $nav
      .find('> .nav-item > .nav-item__link-wrapper .dropdown__toggle')
      .on('click', toggleDropdown);
    $nav
      .find('.subnav-depth-0 .dropdown__toggle')
      .on('click', toggleSubDropdown);
  }

  function closeSlidebarMenu() {
    slideBarToggle.attr('aria-expanded', false);
    $('body').removeClass('mobile-menu-open');
    $(document).off('click.close_slidebar').off('keyup.close_slidebar');
  }

  function tryClosingSlidebarMenu(event) {
    // Keyboard
    if ('undefined' !== typeof event.keyCode) {
      // ESCAPE
      if (27 === event.keyCode) {
        $('.vtx-burger-container').focus();
        closeSlidebarMenu();
      }
    }
    // Click
    else if (!$(event.target).closest('#mobile-menu-wrapper').length) {
      closeSlidebarMenu();
    }
  }

  function openSlidebarMenu() {
    slideBarToggle.attr('aria-expanded', true);
    $('body').addClass('mobile-menu-open');
    $(document)
      .on('click.close_slidebar', tryClosingSlidebarMenu)
      .on('keyup.close_slidebar', tryClosingSlidebarMenu);
  }

  function initMenuMobile() {
    slideBarToggle = $('.vtx-burger-container');

    const $mobileMenu = $('#mobile-menu');

    slideBarToggle.on('click', function (event) {
      event.stopPropagation();

      if ($('body').hasClass('mobile-menu-open')) {
        closeSlidebarMenu();
      } else {
        openSlidebarMenu();
      }
    });

    prepareDropdownForNav($mobileMenu.find('.nav-mobile'));
  }

  function addSubMenuBackBtn() {
    const dropdownSubnavWrapper = $(
      '.dropdown__subnav-wrapper.subnav-wrapper-depth-0 > ul'
    );

    dropdownSubnavWrapper.find('.dropdown').each(function () {
      const backText = $(this)
        .find('> .nav-item__link-wrapper .nav-item__link')
        .text();

      $(this)
        .children('.dropdown__subnav-wrapper')
        .find('.dropdown__subnav')
        .prepend(
          '<li class="nav-item nav-item--back"><div class="nav-item__link-wrapper"><a class="nav-item__link" href="#">' +
            backText +
            '</a></div></li>'
        );
    });

    $('.dropdown__subnav-wrapper .nav-item--back').on(
      'click',
      closeSubDropdown
    );
  }

  $(document).ready(function () {
    initMenuMobile();
    addSubMenuBackBtn();
  });
})(jQuery);
